import { Route, Routes } from "react-router-dom";
import manageUsers from "./module/admin/ManageUsers";
import AdminDashboardComponent from "./module/admin/AdminDashboard";
import dashboardContent from "./module/admin/DashboardContent";
import UserInformation from "./module/admin/UserInformation";
import calendar from "./components/scenes/calendar";
import Logincomponent from "./authentication/Login";
import HomeComponent from "./authentication/HomeComponent";
import Registrationform from "./authentication/Registrationform";
import LandingPage from "./authentication/LandingPage";
import Barchart from "./components/scenes/Barchart";
import { Piechart } from "./components/scenes/Piechart";
import ComposedChart from "./components/scenes/ComposedChart";
import { Linechart } from "./components/scenes/Linechart";
import { DesignerRegister } from "./authentication/DesignerRegister";
import { RecruiterRegister } from "./authentication/RecruiterRegister";
import { PendingReq } from "./module/admin/PendingReq";
import { DesignerDashboard } from "./module/designer/DesignerDashboard";
import { DesignerdashboardContent } from "./module/designer/DesignerdashboardContent";
import { DesignerJobs } from "./module/designer/DesignerJobs";
import { RecruiterDashboard } from "./module/recruiter/RecruiterDashboard";
import { RecruiterDashboardContent } from "./module/recruiter/RecruiterDashboardContent";
import { RecruiterJobPost } from "./module/recruiter/RecruiterJobPost";
import { RecruiterApplicants } from "./module/recruiter/RecruiterApplicants";
import { DesignerProfile } from "./module/designer/DesignerProfile";
import { DesignerEditprofile } from "./module/designer/DesignerEditprofile";
import { ManageRecruiter } from "./module/admin/ManageRecruiter";
import { RecruiterProfile } from "./module/recruiter/RecruiterProfile";
import { RecruiterEditprofile } from "./module/recruiter/RecruiterEditprofile";
import { ManageDesigner } from "./module/admin/ManageDesigner";
import { DesignerConnections } from "./module/designer/DesignerConnections";
import { DesignerSearchProfile} from "./components/UserSearchProfile/DesignerSearchProfile";
import { RecruiterSearchProfile } from "./components/UserSearchProfile/RecruiterSearchProfile";
import { DesignerNotification } from "./module/designer/DesignerNotification";
import { RecruiterConnections } from "./module/recruiter/RecruiterConnections";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';


function App() {
  const navigate = useNavigate();
  useEffect(() => {
    if(!localStorage.getItem('token')){
      // navigate('/login')
    }
    if(localStorage.getItem('token')){
      let role = JSON.parse(localStorage.getItem('Role'));
      let user_id = JSON.parse(localStorage.getItem('user_id'));
      if(role === "designer"){
        navigate(`/designer/dashboard/${user_id}`);
      }else if(role === "recruiter"){
        navigate(`/recruiter/dashboard/${user_id}`);
      }else if(role === "admin"){
        navigate(`/admin/dashboard/${user_id}`);
      }
    } 
  }, []);
  
  return (
      <Routes>
          <Route path="/" element={<LandingPage/>} />
          <Route path="/login" element={<HomeComponent Children={Logincomponent}  />}/>
          <Route path="/register" element={<HomeComponent Children={Registrationform}  />}/>
          <Route path="/register/designer-registration" element={<HomeComponent Children={DesignerRegister}  />}/>
          <Route path="/register/recruiter-registration" element={<HomeComponent Children={RecruiterRegister}  />}/>
         
        {/* Admin component Routing */}
         <Route path="/admin" >
          <Route path="dashboard/:id" element={<AdminDashboardComponent Children={dashboardContent}  />}  />
          <Route path="manage-users" element={<AdminDashboardComponent Children={manageUsers}  />}  />
          <Route path="manage-designer" element={<AdminDashboardComponent Children={ManageDesigner}  />}  />
          <Route path="manage-recruiter" element={<AdminDashboardComponent Children={ManageRecruiter}  />}  />
          <Route path="recruiter-pending-request" element={<AdminDashboardComponent Children={PendingReq}  />}  />
          <Route path="users-information" element={<AdminDashboardComponent Children={UserInformation}  />}  />
          <Route path="calendar" element={<AdminDashboardComponent Children={calendar}  />}  />
          <Route path="bar" element={<AdminDashboardComponent Children={Barchart}  />}  />
          <Route path="pie" element={<AdminDashboardComponent Children={Piechart}  />}  />
          <Route path="line-chart" element={<AdminDashboardComponent Children={Linechart}  />}  />
         </Route>

         <Route path="/designer" >
          <Route path="dashboard/:id" element={<DesignerDashboard Children={DesignerdashboardContent} />}  />
          <Route path="dashboard/jobs" element={<DesignerDashboard Children={DesignerJobs} />}  />
          <Route path="dashboard/profile" element={<DesignerDashboard Children={DesignerProfile} />}  />
          <Route path="dashboard/Edit-profile/:id" element={<DesignerDashboard Children={DesignerEditprofile} />}  />
          <Route path="dashboard/connections" element={<DesignerDashboard Children={DesignerConnections} />}  />
          <Route path="dashboard/notifications/:id" element={<DesignerDashboard Children={DesignerNotification} />}  />
         </Route>
         <Route path="/search/user">
          <Route path="user-profile/designer/:username/:email/:id" element={<DesignerDashboard Children={DesignerSearchProfile} />}  />
          <Route path="user-profile/recruiter/:username/:email/:id" element={<DesignerDashboard Children={RecruiterSearchProfile} />}  />
         </Route>
         <Route path="/user">
         <Route path="user-profile/designer/:username/:email/:id" element={<RecruiterDashboard Children={DesignerSearchProfile} />}  />
          <Route path="user-profile/recruiter/:username/:email/:id" element={<RecruiterDashboard Children={RecruiterSearchProfile} />}  />
         </Route>


         <Route path="/recruiter" >
          <Route path="dashboard/:id" element={<RecruiterDashboard Children={RecruiterDashboardContent} />}  />
          <Route path="dashboard/job-post" element={<RecruiterDashboard Children={RecruiterJobPost} />}  />
          <Route path="dashboard/job-applicants" element={<RecruiterDashboard Children={RecruiterApplicants} />}  />
          <Route path="dashboard/profile" element={<RecruiterDashboard Children={RecruiterProfile} />}  />
          <Route path="dashboard/Edit-profile/:id" element={<RecruiterDashboard Children={RecruiterEditprofile} />}  />
          <Route path="dashboard/connections" element={<RecruiterDashboard Children={RecruiterConnections} />}  />
          
         </Route>
       </Routes> 
  );
}
 
export default App;


